import { IconKeys } from '@ilg-totallymoney/ui/icons/Icon/icons'

import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

import { getCategoryPathForId } from '@utils/getCategoryPathForId'

type CreditCardType = {
    heading: string
    icon: IconKeys
    link: {
        href: string
        linkText: string
    }
    text: string
}

export const creditCardTypes: CreditCardType[] = [
    {
        icon: 'balanceTransferCard',
        heading: 'Balance transfer',
        text: "If you want to cut the interest on your existing debts, a balance transfer credit card is for you. With a balance transfer credit card you can move balances you've accumulated on other credit cards and enjoy 0% interest for a set period of time.",
        link: {
            linkText: 'Compare balance transfer cards',
            href: getCategoryPathForId(
                CreditCardProductCategory.BalanceTransfer
            ),
        },
    },

    {
        icon: 'zeroPurchaseCard',
        heading: 'Purchase',
        text: 'This is the simplest type of credit card. With a purchase card you’ll get a 0% interest period for a set amount of time, allowing you to spend without accruing any interest, even if you don’t pay your balance back in full each month.',
        link: {
            linkText: 'Compare purchase cards',
            href: getCategoryPathForId(CreditCardProductCategory.Purchase),
        },
    },

    {
        icon: 'cashbackCard',
        heading: 'Cashback',
        text: 'If you clear your credit card balance every month, and have no plans to build up any debt, a cashback credit card is a good option. These cards reward your spending habits by giving you a percentage of your spending back in the form of cash.',
        link: {
            linkText: 'Compare cashback cards',
            href: getCategoryPathForId(CreditCardProductCategory.Cashback),
        },
    },

    {
        icon: 'rewardsCard',
        heading: 'Rewards',
        text: 'An alternative option for people who clear their balance each month is a rewards credit card. Rather than paying you back with cash, these cards offer various forms of points in return from using them. These can range from airmiles to supermarket points.',
        link: {
            linkText: 'Compare rewards cards',
            href: getCategoryPathForId(CreditCardProductCategory.Rewards),
        },
    },

    {
        icon: 'travelCard',
        heading: 'Travel',
        text: 'A travel credit card can be a good option for people who travel regularly. They usually carry zero foreign transaction fees, and you’ll often get a better exchange rate than with a regular credit card. Some also come with extras like cashback or points on spending, and airport lounge access.',
        link: {
            linkText: 'Compare travel cards',
            href: getCategoryPathForId(CreditCardProductCategory.Travel),
        },
    },

    {
        icon: 'creditBuilderCard',
        heading: 'Credit builder',
        text: 'If you have poor credit, a poor credit card can help you build your credit rating over time. While they have high interest rates, if you pay your balance in full each month, they can be an effective way of showing lenders you can be trusted.',
        link: {
            linkText: 'Compare credit builder cards',
            href: getCategoryPathForId(CreditCardProductCategory.PoorCredit),
        },
    },
]
